import { useLayoutEffect, useRef, useState } from 'react';

export function useBoxDimensions<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [box, setBox] = useState<{ width: number; height: number } | null>(
    null
  );

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      const { width, height } = entry.contentRect;
      setBox({ width, height });
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []); // Empty array is fine here because 'ref' is instantiated inside the hook

  return [ref, box] as const;
}
